/* bloom-details.js — delivery-details modal (recipient, access, card, options).
 *
 * This file NEVER owns the delivery date or window. Those belong to
 * bloom-datetime.js and are read through window.BloomDelivery. Two pickers for
 * one value is how the old build ended up with five different cut-off rules.
 *
 * It also never writes hidden inputs directly — it goes through
 * BloomDelivery.setProp(), so there is exactly one writer on the product form.
 *
 * Fields are addressed by data-bl-field, and deliberately carry NO name
 * attribute: the modal may sit inside <form action="/cart/add">, and named
 * inputs would be posted to the cart as stray parameters.
 */
(function () {
  var root = document.getElementById('bl-details');
  if (!root || root.dataset.blInit) return;

  var cfgEl = document.querySelector('[data-bl-details-config]');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  root.dataset.blInit = '1';

  var T = C.t, STORE_KEY = 'bloom:details:v1';

  var dlg = document.getElementById('bl-details-dialog'),
      openBtn = root.querySelector('[data-bl-open]'),
      closeBtn = dlg.querySelector('[data-bl-close]'),
      saveBtn = dlg.querySelector('[data-bl-save]'),
      changeBtn = dlg.querySelector('[data-bl-change]'),
      whenEl = dlg.querySelector('[data-bl-when]'),
      sumWhen = root.querySelector('[data-bl-sum-when]'),
      sumWho = root.querySelector('[data-bl-sum-who]'),
      counter = dlg.querySelector('[data-bl-count]');

  var FIELDS = ['recipient', 'phone', 'access', 'message'];
  var TOGGLES = ['call', 'reception', 'photo', 'anon'];

  function field(n) { return dlg.querySelector('[data-bl-field="' + n + '"]'); }
  var msgEl = field('message');

  function read() {
    var d = {};
    FIELDS.forEach(function (n) { var el = field(n); d[n] = el ? el.value.trim() : ''; });
    TOGGLES.forEach(function (n) { var el = field(n); d[n] = el ? !!el.checked : false; });
    return d;
  }

  function write(d) {
    if (!d) return;
    FIELDS.forEach(function (n) { var el = field(n); if (el && d[n]) el.value = d[n]; });
    TOGGLES.forEach(function (n) { var el = field(n); if (el) el.checked = !!d[n]; });
  }

  /* ---- persistence ----------------------------------------------------
   * Survives variant switches and back-navigation. sessionStorage, not local:
   * a recipient's name and phone are someone else's personal data and should
   * not outlive the browsing session.
   */
  function save(d) {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(d)); } catch (e) {}
  }
  function restore() {
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      if (raw) write(JSON.parse(raw));
    } catch (e) {}
  }

  /* ---- property assembly ---------------------------------------------
   * Visible keys are localised, because the customer reads them in the cart
   * and at checkout. One extra hidden key carries the same data in a
   * locale-independent shape — that is the one to read in Flow and exports.
   * The four toggles collapse into ONE property; separate Yes/No rows would
   * push a single line item past nine property rows at checkout.
   */
  function optionList(d) {
    var out = [];
    if (d.call) out.push(T.optCall);
    if (d.reception) out.push(T.optDoor);
    if (d.photo) out.push(T.optPhoto);
    if (d.anon) out.push(T.optAnon);
    return out.join(' \u00b7 ');
  }

  function apply(d) {
    if (!window.BloomDelivery) return;
    var P = window.BloomDelivery.setProp;
    P('properties[' + T.pRecipient + ']', d.recipient);
    P('properties[' + T.pPhone + ']', d.phone);
    P('properties[' + T.pAccess + ']', d.access);
    P('properties[' + T.pCard + ']', d.message);
    P('properties[' + T.pOptions + ']', optionList(d));

    var hasAny = FIELDS.some(function (n) { return d[n]; }) ||
                 TOGGLES.some(function (n) { return d[n]; });
    P('properties[_bloom_details]', hasAny ? JSON.stringify({
      recipient: d.recipient, phone: d.phone, access: d.access,
      message: d.message, call: d.call, reception: d.reception,
      photo: d.photo, anon: d.anon
    }) : '');
  }

  /* ---- summary on the trigger ------------------------------------------ */
  function paintSummary() {
    var s = window.BloomDelivery ? window.BloomDelivery.get() : null;
    var d = read();
    var when = (s && s.date) ? s.dateLabel + ' \u00b7 ' + s.slotLabel : '\u2014';
    if (sumWhen) sumWhen.textContent = when;
    if (whenEl) whenEl.textContent = when;
    if (sumWho) {
      var bits = [];
      if (d.recipient) bits.push(d.recipient);
      if (d.phone) bits.push(d.phone);
      sumWho.textContent = bits.length ? bits.join(' \u00b7 ') : T.missing;
      sumWho.classList.toggle('bl-det__val--empty', !bits.length);
    }
  }

  function paintCounter() {
    if (!counter || !msgEl) return;
    counter.textContent = msgEl.value.length + ' / ' + msgEl.maxLength;
  }

  /* ---- events ----------------------------------------------------------- */
  openBtn.addEventListener('click', function () {
    paintSummary();
    paintCounter();
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  });

  function close() {
    if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
  }
  closeBtn.addEventListener('click', close);

  // Backdrop click closes. Clicks inside the panel must not bubble to here.
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });

  if (msgEl) msgEl.addEventListener('input', paintCounter);

  changeBtn.addEventListener('click', function () {
    close();
    var picker = document.getElementById('bl-dt');
    if (!picker) return;
    picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    picker.classList.add('bl-dt--flash');
    setTimeout(function () { picker.classList.remove('bl-dt--flash'); }, 1200);
  });

  saveBtn.addEventListener('click', function () {
    var d = read();
    apply(d);
    save(d);
    paintSummary();
    var label = saveBtn.textContent;
    saveBtn.textContent = T.saved;
    saveBtn.disabled = true;
    setTimeout(function () {
      saveBtn.textContent = label;
      saveBtn.disabled = false;
      close();
    }, 550);
  });

  // Date or window changed on the inline picker — keep the trigger honest.
  document.addEventListener('bloom:delivery-change', paintSummary);

  restore();
  apply(read());
  paintSummary();
  paintCounter();
})();
